import { render, staticRenderFns } from "./Depense.vue?vue&type=template&id=5db1695e"
import script from "./Depense.vue?vue&type=script&lang=js"
export * from "./Depense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports